import { TablePagination, TableRow } from "@mui/material";
import { formatPaginationLabel } from "./helpers";
import { TablePaginationProps } from "./types";
import { TablePaginationOwnProps } from "@mui/material/TablePagination/TablePagination";

const TablePaginationComponent = ({
  count,
  pageIndex,
  pageSize,
  onPageChange,
  rowsPerPageOptions,
  wrapInRow = true,
}: TablePaginationProps) => {
  const paginationProps: TablePaginationOwnProps = {
    sx: { border: "none" },
    count: count.value,
    page: pageIndex,
    rowsPerPage: pageSize,
    onPageChange,
    rowsPerPageOptions: rowsPerPageOptions || [], // not shown if empty
    labelDisplayedRows: (args: Parameters<typeof formatPaginationLabel>[1]) =>
      formatPaginationLabel(count, args),
  };

  if (!wrapInRow) {
    return <TablePagination component="div" {...paginationProps} />;
  }

  return (
    <TableRow>
      <TablePagination {...paginationProps} />
    </TableRow>
  );
};

export default TablePaginationComponent;
